import React from 'react';
import { ProviderHome } from './ProviderHome';

export function LawyerHome() {
  return <ProviderHome providerType="lawyer" />;
}
